import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  template: `
    <div class="error-wrapper">
      <div class="container">

        <div class="error-heading">
          <h2 class="headline font-danger">403</h2>
        </div>
        <div class="col-md-8 offset-md-2">
          <p class="sub-content">
            You don't have permission to access this page.
            Please contact your administrator if you believe this is a mistake.
          </p>
        </div>
        <div>
          <button class="btn btn-primary btn-lg" (click)="navigateToHome()">BACK TO HOME PAGE</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .error-wrapper {
      text-align: center;
      padding: 60px 15px;
    }
    .img-100 {
      width: 150px;
      margin-bottom: 20px;
    }
    .headline {
      font-size: 100px;
      margin: 0;
    }
    .font-danger {
      color: #0798eb !important;
    }
    .sub-content {
      font-size: 18px;
      margin: 20px 0;
    }
    .btn-lg {
      margin-top: 20px;
    }
  `]
})
export class AccessDeniedComponent {
  constructor(private router: Router) { }

  navigateToHome() {
    this.router.navigate(['/']);
  }
}
